import React from 'react'
import { LinkButton } from '../../common/menu/linkButton'
import { HomeHeading } from './Heading'
import { TitleHighlight } from '../../ui/typo/TitleHighlight'

export const Hero = () => (
  <section className="flex justify-center py-8 mb-8 md:mb-12 lg:mb-16 xl:mb-18">
    <div className="container flex flex-col items-center px-4 space-y-4 lg:space-y-8">
      <HomeHeading tag="h1" additionalClasses="text-center">
        Trouve ton <TitleHighlight>prochain job</TitleHighlight> en cabinet
        d’expertise et de conseil
      </HomeHeading>

      <div className="flex flex-col items-center space-y-4 md:flex-row md:justify-center md:space-x-4 md:space-y-0">
        <LinkButton
          label="Lance ta recherche personnalisée"
          href="/offres"
          title="Lance ta recherche personnalisée"
          isInverted
        />
        <LinkButton
          label="Mon cabinet recrute"
          href="/je-suis-un-cabinet"
          title="Déposer des offres d'emploi sur lamacompta"
        />
      </div>
    </div>
  </section>
)
